export default __webpack_public_path__ + "static/media/error.4a0f807d.svg";